<template>
  <div class="w-100 my-5">
    <div v-if="orderList">
      <div class="row" v-if="items.length > 0">
        <div v-for="(item, index) in items" :key="(item, index)">
          <div :class="`box-white p-0 d-flex flex-column ${ isMobile ? 'mx-1 mt-5' : 'm-5' }`" style="width: 330px">
            <div :id="`divOrderDetail_${index}`" class="position-relative">
              <div id="cardOrderDetail">
                <img class="m-5" :height="30" :src="assets.logoDark" />
                <div class="m-5 d-flex flex-column" v-if="item.eventInfo">
                  <span class="mt-5 font-bold font-18">{{ item.eventInfo.name }}</span>
                  <div class="mt-5 vertical-center">
                    <i class="fa fa-calendar-alt font-12 color-purple"></i>
                    <span class="ml-2 font-12 color-purple">{{ getDateStringFromTimestamp(item.eventInfo.startAt) }} - {{ getDateStringFromTimestamp(item.eventInfo.endAt)}}</span>
                  </div>
                  <div class="mt-5 vertical-center">
                    <i class="flaticon2-pin-1 font-12"></i>
                    <span class="ml-2 font-12">{{ item.eventInfo.address }}</span>
                  </div>
                </div>
                <div class="m-5 d-flex flex-column">
                  <span class="font-bold font-18">{{ item.ticketName }}</span>
                  <div class="mt-2 vertical-center">
                    <span class="font-bold font-18">No:</span>
                    <span class="ticket-number ml-2 font-bold font-18">{{ item.ticketNumber }}</span>
                  </div>
                  <VueQrcode
                    class="mx-auto"
                    :value="item.orderId"
                    :options="qrOptions"
                    level="H"
                  />
                </div>
              </div>
              <img class="official-ticket" :src="assets.officialTicket" />
            </div>
            <div class="m-5 d-flex justify-content-between vertical-center">
              <div class="d-flex flex-column">
                <span class="font-12">Created: {{ getDateStringFromTimestamp(item.createdAt) }}</span>
                <span class="mt-2 font-12">Check-in: {{ getDateStringFromTimestamp(item.usedAt) }}</span>
              </div>
              <div class="d-flex">
                <v-btn
                  style="z-index: 10"
                  icon
                  small
                  @click="downloadOrderDetail(item, index)"
                >
                  <i class="flaticon-download font-bold font-25 color-purple"></i>
                </v-btn>
                <v-btn
                  class="ml-5"
                  style="z-index: 10"
                  icon
                  small
                  @click="exportOrderConfirmation(item, index)"
                >
                  <i class="flaticon-file-2 font-bold font-25 color-purple"></i>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="my-30 py-40 center" v-else>
        <p>{{ $t("no_data_found") }}</p>
      </div>
    </div>
    <div class="py-40 center" v-else>
      <p>{{ $t("please_wait") }}</p>
      <b-spinner type="grow"></b-spinner>
    </div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1900"
      :pdf-quality="2"
      :manual-pagination="true"
      :html-to-pdf-options="htmlToPdfOptions"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="d-flex flex-column">
          <div class="d-flex justify-content-end px-10">
            <img :src="assets.logo" :height="30" />
          </div>
          <div class="my-10 font-20 font-bold color-purple px-10">
            {{ $t("order_confirmation") }}
          </div>
          <div class="w-100 d-flex mb-10 px-10">
            <div class="w-50"></div>
            <div class="w-50">
              <div class="d-flex">
                <div class="w-50 font-15">{{ $t("date") }}</div>
                <div class="w-50">{{ this.orderPdfInfo.createdAt }}</div>
              </div>
              <div class="d-flex">
                <div class="w-50 font-15">{{ $t("payment_method") }}</div>
                <div class="w-50">{{ this.orderPdfInfo.paymentMethod }}</div>
              </div>
            </div>
          </div>

          <div class="w-100 d-flex mb-10 px-10">
            <div class="w-50">
              <div class="d-flex">
                <div class="w-50 font-15">{{ $t("payer") }}</div>
                <div class="w-50">{{ this.orderPdfInfo.buyerName }}</div>
              </div>
              <div class="d-flex">
                <div class="w-50 font-15">{{ $t("transaction_id") }}</div>
                <div class="w-50">{{ this.orderPdfInfo.transactionId }}</div>
              </div>
            </div>
          </div>

          <div class="my-10 px-10">
            {{ $t("thanks_your_purchase") }}
          </div>

          <div
            class="border-top-2 w-100 mb-2"
            style="border-top: 2px solid purple"
          ></div>

          <div class="w-100 d-flex mb-10 p-10">
            <div class="w-75">
              <div class="d-flex">
                <div class="w-50 font-15">No.</div>
                <div class="w-50 font-15">{{ $t("description") }}</div>
              </div>
              <div class="d-flex">
                <div class="w-50">{{ this.orderPdfInfo.ticketNumber }}</div>
                <div class="w-50">{{ this.orderPdfInfo.ticketName }}</div>
              </div>
            </div>
            <div class="w-25">
              <div class="d-flex">
                <div class="w-50 font-15">
                  {{ $t("price") }}
                </div>
              </div>
              <div class="d-flex">
                <div class="w-50">{{ this.orderPdfInfo.price }}</div>
              </div>
            </div>
          </div>

          <div class="px-10">
            {{ $t("you_can_find_your_ticket_in") }}
          </div>

          <div class="my-5 px-10">Ihr eventbox Team</div>

          <div
            class="border-top-2 w-100 mb-2 mt-10"
            style="border-top: 2px solid purple"
          ></div>

          <div class="mb-10 p-10 text-center">
            <div>Eventbox UG</div>
            <div>Geschäftsstelle: München</div>
            <div>Amtsgericht München, HRB 281964</div>
          </div>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>

<style scoped>
.ticket-number {
  padding: 5px 15px;
  background: #d3d3d3 !important;
  border-radius: 5px !important;
}
.official-ticket {
  width: 130px;
  height: 130px;
  position: absolute;
  top: 0;
  right: 0;
}
</style>

<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";
import VueHtml2pdf from "vue-html2pdf";
import html2canvas from "html2canvas";

import { onSnapshot, query, collection, where, getDocs } from "firebase/firestore";
import { firestore } from "../../../main";
import { getDateStringFromTimestamp, toFileName, showLoading, getPriceFormat } from "../../../functions";

import logoDark from "@/assets/image/logo_dark.png";
import logo from "@/assets/image/logo_for_invoice.png";
import officialTicket from "@/assets/image/official_ticket.png";

export default {
  name: "TicketList",
  components: {
    VueQrcode,
    VueHtml2pdf,
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    eventList() {
      return this.$store.state.eventList || [];
    },
  },
  watch: {
    eventList() {
      this.refreshData();
    },
  },
  data() {
    return {
      assets: {
        logoDark,
        logo,
        officialTicket,
      },
      orderPdfInfo: {
        createdAt: "",
        paymentMethod: "Free",
        buyerName: "",
        transactionId: "",
        ticketNumber: "",
        ticketName: "",
        price: "",
      },
      htmlToPdfOptions: {
        margin: 10,
        filename: "order_confirmation",
        image: {
          type: "jpeg",
          quality: 1.0,
        },
        html2canvas: {
          scale: 5,
          useCORS: true,
        },
      },
      qrOptions: {
        width: 280,
        color: {
          dark: "#170223",
          light: "#FFFFFF",
        },
      },
      visibleOrderDetailDialog: false,
      snapOrderList: null,
      orderList: null,
      cacheUserList: [],
      items: [],
    };
  },
  mounted() {
    this.cacheUserList = this.$store.state.userList;
    this.getOrderListTask();
  },
  destroyed() {
    if (this.snapOrderList) {
      this.snapOrderList();
    }
  },
  methods: {
    getDateStringFromTimestamp,
    getPriceFormat,
    refreshData() {
      const items = [];
      this.orderList.forEach((orderInfo) => {
        const buyerInfo = this.cacheUserList.find(element => element.userId === orderInfo.buyerId);
        orderInfo.buyerName = buyerInfo ? buyerInfo.userName : "";
        orderInfo.eventInfo = this.eventList.find(element => element.eventId === orderInfo.eventId);
        items.push(orderInfo);
      });
      this.items = items;
    },
    downloadOrderDetail(orderInfo, index) {
      const loader = showLoading(this, 1);
      const options = {
        type: "dataURL",
      };
      html2canvas(document.getElementById(`divOrderDetail_${index}`), options).then((canvas) => {
        const link = document.createElement("a");
        const fileName = `${orderInfo.buyerName}_${toFileName(orderInfo.ticketName)}_${orderInfo.ticketNumber}.jpg`;
        link.setAttribute("download", fileName);
        link.setAttribute("href", canvas.toDataURL("image/jpg").replace("image/jpg", "image/octet-stream"));
        link.click();
        loader.hide();
      });
    },
    getUserListTask(userIDs) {
      const q = query(collection(firestore, 'user'), where('userId', 'in', userIDs));
      getDocs(q).then(querySnapshot => {
        const list = [];
        querySnapshot.forEach(doc => {
          const data = doc.data();
          const deviceType = data.deviceType || '';
          if (window.location.hostname === 'localhost') {
            data['deviceType'] = deviceType;
            if (deviceType.startsWith('Android : ')) {
              data['deviceTypeColor'] = 'color-red';
            } else if (deviceType.startsWith('iOS : ')) {
              data['deviceTypeColor'] = 'color-blue';
            } else if (deviceType.startsWith('Web : ')) {
              data['deviceTypeColor'] = 'color-purple';
            }
          } else {
            const myArray = deviceType.split(' : ');
            if (myArray && myArray.length > 0) {
              data['deviceType'] = myArray[0];
            } else {
              data['deviceType'] = '';
            }
            data['deviceTypeColor'] = 'color-primary';
          }
          if (data.userId === this.$route.params.userId) {
            this.userInfo = data;
          }
          list.push(data);
        });
        this.cacheUserList = this.cacheUserList.concat(list);
        this.$store.commit('set', ['userList', this.cacheUserList]);
        this.refreshData();
      });
    },
    async exportOrderConfirmation(orderInfo, index) {
      // Query transactionInfo from firebase
      const q = query(collection(firestore, "transaction"), where("transactionId", "==", orderInfo.transactionId));
      const querySnapshot = await getDocs(q);
      if (querySnapshot.empty) {
        this.$toast.error("Unexpected error");
        return;
      }
      let transactionId = "";
      let paymentMethod = "Free";

      const transactionInfo = querySnapshot.docs[0].data();
      const fileName = `${orderInfo.buyerName}_${toFileName(orderInfo.ticketName)}_${orderInfo.ticketNumber}.pdf`;
      this.htmlToPdfOptions.filename = fileName;
      // Set order pdfInfo
      if (orderInfo.transactionId.startsWith(this.PAYMENT_TYPE_PAYPAL)) {
        paymentMethod =
          transactionInfo.paymentMethod === ""
            ? "PayPal"
            : transactionInfo.paymentMethod;
        const splits = orderInfo.transactionId.split("-");
        transactionId = splits.length > 0 ? splits[splits.length - 1] : "";
      } else if (orderInfo.transactionId.startsWith(this.PAYMENT_TYPE_STRIPE)) {
        paymentMethod = transactionInfo.paymentMethod;
        const splits = orderInfo.transactionId.split("-");
        transactionId = splits.length > 0 ? splits[splits.length - 1] : "";
      }
      const price =
        transactionInfo?.details?.find(
          (detail) => detail.ticketId === orderInfo.ticketId
        )?.price || 0;

      this.orderPdfInfo = {
        createdAt: getDateStringFromTimestamp(orderInfo.createdAt),
        transactionId,
        paymentMethod,
        price: getPriceFormat(price),
        buyerName: orderInfo.buyerName,
        ticketNumber: `No. ${orderInfo.ticketNumber}`,
        ticketName: orderInfo.ticketName,
      };
      this.$refs.html2Pdf.generatePdf();
    },
    getOrderListTask() {
      if (this.snapOrderList) {
        return;
      }
      const q = query(
        collection(firestore, "order"),
        where("transactionId", "==", this.$route.params.transactionId)
      );
      this.snapOrderList = onSnapshot(q, (querySnapshot) => {
        const orderList = [];
        var userIDs = [];
        querySnapshot.forEach(doc => {
          const data = doc.data();
          orderList.push(data);
          if (!this.cacheUserList.find(element => element.userId === data.buyerId)) {
            userIDs.push(data.buyerId);
            if (userIDs.length >= 30) {
              this.getUserListTask(userIDs);
              userIDs = [];
            }
          }
        });
        orderList.sort((a, b) => (b.ticketNumber < a.ticketNumber ? 1 : -1));
        this.orderList = orderList;
        this.refreshData();
        if (userIDs.length > 0) {
          this.getUserListTask(userIDs);
        }
      });
    },
  },
};
</script>
